import React from 'react';
import { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function GeneratedSingle({imguuid}) {

  const [images, setImages] = useState([]);
  const [results, setResults] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await fetch(`${API_URL}/api/image/${imguuid}`);
      if (response.ok) {
        const results = await response.json();
        setImages(results.image_url);
        setResults(results);
      }
      else {
        setImages([]);
        setResults(results);
      }
    })();
  }, []);

  const printme = () => {
    // Define your HTML content for printing
    const myPrintContent = `
      <html>
        <head>
          <title>Print</title>
        </head>
        <body>
          <h2 style="text-align:center;font-family:sans-serif;"><b>${results.user_prompt}</b></h2>
          
          <h3 style="text-align:center;font-family:sans-serif;">Created by me at www.babyboo.dev/butterpuppies</h3>
          <hr>
          <div style="width:100%;font-family:sans-serif;color:grey;text-align: center;">Artist Signature</div>
        </body>
      </html>
    `;

    // Open a new window
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      // Write the content to the new window
      printWindow.document.write(myPrintContent);

      // Invoke the print dialog
      printWindow.document.close(); // Necessary for some browsers
      printWindow.focus(); // Necessary for some browsers
      printWindow.print();
      printWindow.close(); // Close the window after printing (optional)
    }
  };
  
  return (
    <>
      <div className="container">
        <div className="container">
          <div className="row justify-content-center mt-2">
            <div className="col-md-6 col-sm-12">
              <div className="text-center">
                <h4 className="print">
                  <b>{results.user_prompt}</b>
                  
                </h4>
                <img
                  id="coloringpage"
                  className="img-fluid message bot"
                  src={results.image_url}
                  alt= {results.user_prompt}
                />
                <div id="prompt" className="message user gap-2 py-3">
                  {/* Display paginated items */}
                </div>
                <button
                  className="btn btn-primary active m-1"
                  onClick={printme}
                >
                  <b>
                    <i className="fa fa-print" aria-hidden="true"></i> Print this
                    image
                  </b>
                </button>
                <button
                  className="btn btn-primary btn-block m-1"
                  onClick={() => (window.location.href = '/')}
                >
                  <b>Click here to create your own!</b>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
